import axios from "axios";

import { usersSlice, callTypes } from "./usersSlice";
const API_URL = process.env.REACT_APP_API_URL;

const { actions } = usersSlice;

export const usersFetch = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return axios
    .get(API_URL + `restless-users/all`, {
      params: { _limit: -1, _sort: "registration_dt:DESC" },
    })
    .then((response) => {
      dispatch(actions.usersFetched({ usersList: response.data }));
    })
    .catch((err) => {
      dispatch(actions.catchError({ error: err, callType: callTypes.action }));
    });
};

export const fetchUser = (id) => (dispatch) => {
  if (!id) {
    return dispatch(actions.userFetched({ userForDetails: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return axios
    .get(API_URL + `restless-users/${id}`)
    .then((response) => {
      dispatch(actions.userFetched({ userForDetails: response.data.user }));
    })
    .catch((err) => {
      dispatch(actions.catchError({ error: err, callType: callTypes.action }));
    });
};

export const disabledUser = ({ id, disableOnSelf = false, disableOnSocial = false }) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.disabled }));

  return axios
    .put(API_URL + `restless-users/${id}/disable?disable_on_self=${disableOnSelf}&disable_on_social=${disableOnSocial}`)
    .then((response) => {
      dispatch(actions.userDisabled({ userDisabled: response.data }));
    })
    .catch((err) => {
      dispatch(
        actions.catchError({ error: err, callType: callTypes.disabled })
      );
    });
};

export const kickedUser = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.kickout }));

  return axios
    .put(API_URL + `/restless-users/${id}/kick-out`)
    .then((response) => {
      dispatch(actions.userKickedOut({ userKicked: response.data }));
    })
    .catch((err) => {
      dispatch(actions.catchError({ error: err, callType: callTypes.kickout }));
    });
};

export const promoteToAdmin = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.promoteusertoadmin }));

  return axios
    .put(API_URL + `/restless-users/${id}/admin`)
    .then((response) => {
      dispatch(actions.userToAdmin({ userToAdmin: response.data }));
    })
    .catch((err) => {
      dispatch(
        actions.catchError({
          error: err,
          callType: callTypes.promoteusertoadmin,
        })
      );
    });
};

export const promoteToVerified = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.promotetouserverified }));

  return axios
    .put(API_URL + `/restless-users/${id}/verified`)
    .then((response) => {
      dispatch(actions.userToVerified({ userToVerified: response.data }));
    })
    .catch((err) => {
      dispatch(
        actions.catchError({
          error: err,
          callType: callTypes.promotetouserverified,
        })
      );
    });
};

export const shadowbanUser = (user, values) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.shadowban }));
  const body = {
    shadowbanned: values.shadowban,
  };
  return axios
    .put(API_URL + `/restless-users/${user.id}/shadowban`, body)
    .then((response) => {
      dispatch(actions.userShadobanned({ userShadowbanned: response.data }));
    })
    .catch((err) => {
      dispatch(
        actions.catchError({ error: err, callType: callTypes.shadowban })
      );
    });
};

export const reenableUser = ({ user, reEnableOnSocial = false, reEnableOnSelf = false }) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.reenable }));

  return axios
    .put(API_URL + `restless-users/${user.id}/re-enable?reenable_on_self=${reEnableOnSelf}&reenable_on_social=${reEnableOnSocial}`)
    .then((response) => {
      dispatch(actions.userReenabled({ userReenabled: response.data }));
    })
    .catch((err) => {
      dispatch(
        actions.catchError({ error: err, callType: callTypes.reenable })
      );
    });
};

export const userInformation = (userId) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.information }));

  return axios
    .get(API_URL + `/restless-users/${userId}/info`)
    .then((response) => {
      dispatch(
        actions.userInformationFetched({ userInformation: response.data.info })
      );
    })
    .catch((err) => {
      dispatch(
        actions.catchError({ error: err, callType: callTypes.information })
      );
    });
};

export const cleanErrors = (dispatch) => {
  dispatch(
    actions.catchError({ error: null, callType: callTypes.information })
  );
};

export const cleanStateUsers = (dispatch) => {
  dispatch(actions.userDisabled({ userDisabled: null }));
  dispatch(actions.userKickedOut({ userKicked: null }));
  dispatch(actions.userToAdmin({ userKicked: null }));
  dispatch(actions.userToVerified({ userToVerified: null }));
  dispatch(actions.userShadobanned({ userShadowbanned: null }));
  dispatch(actions.userReenabled({ userReenabled: null }));
};

export const fetchMentions = async (keyword, dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.information }));

  return axios
    .get(API_URL + "/restless-users", {
      params: { full_name_contains: keyword },
    })
    .then((response) => {
      dispatch(actions.usersFetched({ usersList: response.data }));
    })
    .catch((err) => {
      dispatch(
        actions.catchError({ error: err, callType: callTypes.information })
      );
    });
};

export const fetchSearch = async (text, dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.information }));

  return axios
    .get(API_URL + "/restless-users/search", {
      params: {
        _start: 0,
        _limit: -1,
        text,
        remove_self: 0,
        add_flags: 0
      },
    })
    .then((response) => {
      dispatch(actions.usersFetched({ usersList: response.data }));
    })
    .catch((err) => {
      dispatch(
        actions.catchError({ error: err, callType: callTypes.information })
      );
    });
};